import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const AffectedItemsDamageInternationalStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS_DAMAGE_INTERNATIONAL
};
